import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';

import {PipesModule} from '../../pipes/pipes.module';

import {SelectComponent} from './select';
import {HighlightPipe} from './select-pipes';

@NgModule({
  imports: [CommonModule, TranslateModule, PipesModule],
  declarations: [SelectComponent, HighlightPipe],
  exports: [SelectComponent, HighlightPipe]
})
export class SelectModule {
}
